import script from "./projectList.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectList.vue?vue&type=script&lang=ts&setup=true"

import "./projectList.vue?vue&type=style&index=0&id=4ba341ab&lang=less"

const __exports__ = script;

export default __exports__